// Presentation mirrors the correction command's dependent goods expansion. Keep
// the original selected IDs for POST/replay so saved idempotency inputs never change.
export function effectiveReturnSelection(lines: Array<{id: string; parentOrderItemId?: string | null; returned: boolean; service: boolean; linkedGoodsMinor?: Record<string,number>; catchUpMinor?: number}>, selected: string[]) {
  const effective = new Set(selected);
  const goods = new Set(lines.filter(line => !line.service).map(line => line.id));
  let changed = true;
  while (changed) {
    changed = false;
    for (const line of lines) {
      if (!line.service && !line.returned && line.parentOrderItemId && goods.has(line.parentOrderItemId) && effective.has(line.parentOrderItemId) && !effective.has(line.id)) {
        effective.add(line.id);
        changed = true;
      }
    }
  }
  for (const line of lines) {
    if (line.service && !line.returned && line.linkedGoodsMinor && [...effective].some(id => goods.has(id)) &&
        (Object.entries(line.linkedGoodsMinor).some(([id,amount]) => amount > 0 && effective.has(id)) || (line.catchUpMinor ?? 0) > 0)) effective.add(line.id);
  }
  return [...effective];
}

export function selectedReturnAmount(line: {id:string;grossMinor:number;service:boolean;linkedGoodsMinor?:Record<string,number>;catchUpMinor?:number}, effective:string[], explicit:string[]) {
  if (!effective.includes(line.id)) return 0;
  if (!line.service || !line.linkedGoodsMinor || explicit.includes(line.id)) return line.grossMinor;
  return Math.min(line.grossMinor, (line.catchUpMinor ?? 0) + Object.entries(line.linkedGoodsMinor).reduce((sum,[id,amount]) => sum + (effective.includes(id) ? amount : 0),0));
}

// Existing completed goods returns may predate automatic service shares. Prepare
// their remaining linked credit, still requiring the normal reason and confirmation.
export function automaticOrphanServices(lines: Array<{id:string;service:boolean;returned:boolean;grossMinor:number;linkedGoodsMinor?:Record<string,number>;catchUpMinor?:number}>) {
  const goods = lines.filter(line => !line.service);
  if (!goods.length || goods.some(line => !line.returned)) return [];
  return lines.filter(line => line.service && !line.returned && line.linkedGoodsMinor && line.grossMinor > 0 && (line.catchUpMinor ?? 0) >= line.grossMinor).map(line => line.id);
}
